import { useEffect } from 'react';
import { SUBSCRIPTION_ANALYTICS } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscription.analytics';
import { sendDwh } from 'reactApp/utils/ga';

import { DwhData } from '../CancelAutoRenewalModal.types';

export const useSendAnalyticAfterOpen = (dwhData: DwhData, freezeAutoRenewalEnabled = false) => {
    // TODO: заменить на `useFirstEffect`
    // Возможно, стоит переименовать `useFirstEffect` в `useEffectOnce`
    useEffect(() => {
        sendDwh({
            ...SUBSCRIPTION_ANALYTICS.MY_TARIFF_CANCEL_STEP0_OPEN,
            dwhData,
        });
        // tempexp_14269-start
        if (freezeAutoRenewalEnabled) {
            sendDwh({
                ...SUBSCRIPTION_ANALYTICS.FREEZE_RENEWAL_SHOW,
                dwhData,
            });
        }
        // tempexp_14269-end
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
